/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Close_MenuInputs */



/**
* | output |
* | --- |
* | "Close menu" |
*
* @param {Nav_Close_MenuInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const nav_close_menu = /** @type {((inputs?: Nav_Close_MenuInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Close_MenuInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Sluit menu")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer le menu")
	return /** @type {LocalizedString} */ ("Close menu")
});